import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    flexShrink: 0,
  },

  headerTitle: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
  },

  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
    flexShrink: 0,
  },

  actionError: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },

  hardDeleteItem: {
    color: tokens.colorPaletteRedForeground1,
  },

  hardDeleteConfirmButton: {
    backgroundColor: tokens.colorPaletteRedBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
    ':hover': {
      backgroundColor: tokens.colorPaletteRedForeground1,
    },
  },

  deleteError: {
    color: tokens.colorPaletteRedForeground1,
    marginTop: tokens.spacingVerticalS,
    display: 'block',
  },

  tabBar: {
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    paddingLeft: tokens.spacingHorizontalL,
    flexShrink: 0,
    minWidth: 0,
    overflowX: 'auto',
  },

  tabContent: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
    padding: tokens.spacingVerticalL,
  },

  viewerFill: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    minWidth: 0,
  },
  routedContent: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: tokens.spacingVerticalS,
  },

  versionBanner: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    marginBottom: tokens.spacingVerticalM,
    backgroundColor: tokens.colorNeutralBackground3,
    borderRadius: tokens.borderRadiusMedium,
    position: 'sticky' as const,
    top: 0,
    zIndex: 1,
  },

  versionBannerText: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold as unknown as number,
    color: tokens.colorNeutralForeground1,
  },

  versionBannerDraftButton: {
    marginLeft: 'auto',
    color: tokens.colorBrandForegroundLink,
    borderTopColor: tokens.colorBrandForegroundLink,
    borderRightColor: tokens.colorBrandForegroundLink,
    borderBottomColor: tokens.colorBrandForegroundLink,
    borderLeftColor: tokens.colorBrandForegroundLink,
  },
});
